import {
  ChangeDetectionStrategy,
  Component,
  DestroyRef,
  EventEmitter,
  inject,
  Input,
  OnInit,
  Output,
  WritableSignal,
} from '@angular/core';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CheckBoxAndLabelInterface } from '@interfaces/contact/check-box-and-label-interface';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
  selector: 'ln-left-checkbox-and-label',
  imports: [FormsModule, ReactiveFormsModule],
  templateUrl: './left-checkbox-and-label.component.html',
  styleUrl: './left-checkbox-and-label.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LeftCheckboxAndLabelComponent implements OnInit {
  // private TAG = 'LeftCheckboxAndLabelComponent';
  @Input({ required: true }) checkBoxAndLabelInterface!: WritableSignal<CheckBoxAndLabelInterface>;
  @Output() updateSelected = new EventEmitter<CheckBoxAndLabelInterface>();
  form: FormGroup;
  private destroyRef = inject(DestroyRef);
  constructor() {
    this.form = new FormGroup({
      selected: new FormControl<boolean>(false, { nonNullable: true }),
    });
  }
  ngOnInit(): void {
    const checkBoxAndLabelInterface = this.checkBoxAndLabelInterface();
    this.form.patchValue({ selected: checkBoxAndLabelInterface.state });
    this.listenWhenSelectedChange();
  }

  toggleSelect(): void {
    const checkBoxAndLabelInterface = this.checkBoxAndLabelInterface();
    this.form.patchValue({ selected: !checkBoxAndLabelInterface.state });
  }

  listenWhenSelectedChange(): void {
    this.form.controls['selected'].valueChanges.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(value => {
      const isSelected: boolean = value;
      const checkBoxAndLabelInterface: CheckBoxAndLabelInterface = {
        id: this.checkBoxAndLabelInterface().id,
        state: isSelected,
        label: this.checkBoxAndLabelInterface().label,
      };
      this.checkBoxAndLabelInterface.set(checkBoxAndLabelInterface);
      this.updateSelected.emit(this.checkBoxAndLabelInterface());
    });
  }
}
